import styled from 'styled-components';
import { Box } from '@flexisaf/flexibull2';

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20rem 0;
`;

export const FormBox = styled(Box)`
  opacity: 1;
  & .flexi-layout {
    min-height: max-content;

    & .flexi-wizard {
      padding-bottom: 0;
      margin: 0 auto;

      & > .flexi-wizard-wrapper {
        padding-bottom: 0;
      }
    }
  }

  & .save-continue {
    display: flex;
    justify-content: space-between;
    padding: 20px 50px 25px 0;
    border-top: 1px solid #d8d8e6;
    position: fixed;
    bottom: 0;
    z-index: 99;

    @media(max-width: 800px ) {
      padding: 1.8rem 2rem 5rem 1rem;
    }



    & .save-button {
      font-family: "Inter";
      border-radius: 3px;
      font-weight: 500;
    }
  }
  
`


export const FormWrapper = styled(Box)`
  & .applicant-info {
    margin-top: 38px;
    & > div {
      &:first-child {
        margin-top: 0;
      }

      & .form-grid {
        margin-right: 20px;
        border-bottom: 1px solid ${(props) => props.theme.PrimaryBorderColor};

        & .single-form {
          border-bottom: 1px solid ${(props) => props.theme.PrimaryBorderColor};
          margin-bottom: -1px;

          &:last-child {
            border-bottom: 0;
          }
        }
      }
    }
  }

  padding-bottom: 30px;

  .form-actions,
  .print-form {
    @media print {
      display: none;
    }
  }
`;